var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item",class:{translucent: _vm.contentItem.translucent},attrs:{"id":_vm.contentItem.contentItemId}},[_c('span',{staticClass:"mi-folder-open top-0 mr-1",style:(_vm.defaultStyles)}),_c('span',{staticClass:"ellipsis-nowrap"},[_vm._v(_vm._s(_vm.contentItem.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }